import { createTheme } from '@one-thd/sui-atomic-components';

const SecondarySpringDarkGreen = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

SecondarySpringDarkGreen.palette['--sui-palette-background-primary'] = '73 121 50';
SecondarySpringDarkGreen.palette['--sui-palette-button-background-primary'] = '255 255 255';
SecondarySpringDarkGreen.palette['--sui-palette-text-primary'] = '255 255 255';
SecondarySpringDarkGreen.palette['--sui-palette-text-subtle'] = '255 255 255';

export { SecondarySpringDarkGreen };